import { TableCell, Typography } from "@mui/material";
import TableFooter from "@mui/material/TableFooter";
import TableRow from "@mui/material/TableRow";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

export default function NoRecordsTableFooter({ colspan, style }) {
    const { t } = useTranslation();
    return (
        <TableFooter>
            <TableRow>
                <TableCell colspan={colspan}>
                    <Typography
                        textAlign="center"
                        variant="overline"
                        display="block"
                        gutterBottom
                        style={{
                            margin: 0,
                            fontSize: "20px",
                            color: "var(--primary)",
                            ...style,
                        }}
                    >
                        {t("no_records")}
                    </Typography>
                </TableCell>
            </TableRow>
        </TableFooter>
    );
}

NoRecordsTableFooter.propTypes = {
    colspan: PropTypes.number,
};
NoRecordsTableFooter.defaultProps = {
    colspan: 0,
};
